import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=8974b302&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/borno-cct/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8974b302')) {
      api.createRecord('8974b302', component.options)
    } else {
      api.reload('8974b302', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=8974b302&", function () {
      api.rerender('8974b302', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/setting/trench/edit.vue"
export default component.exports